import { Component, Input, OnInit } from '@angular/core';
import { CreatorColumnGenericComponent } from '../creator-column-generic/creator-column-generic.component';
import { CreatorResponseDto } from '../../../../common/general-types/creators.dto';
import { VideoFormatEnum } from '../../../../common/general-types/briefs.dto';

@Component({
  selector: 'creator-card-blue',
  standalone: true,
  imports: [CreatorColumnGenericComponent],
  templateUrl: './creator-card-blue.component.html',
  styleUrl: './creator-card-blue.component.css'
})
export class CreatorCardBlueComponent implements OnInit {

  @Input() creator!: CreatorResponseDto; 
  VideoFormatEnum = VideoFormatEnum;

  ngOnInit(): void {
    
  }
}
